import InsertLinkIcon from "@mui/icons-material/InsertLink";
import { IconButton, Tooltip } from "@mui/material";
import { Link } from "react-router-dom";

const CustomUniqueURLIcon = ({ ...props }) => {
  return (
    <Tooltip title={props?.label || "Unique URL"} placement="left" arrow>
      {/* <Link to={props.to}> */}
      <IconButton {...props}>
        <InsertLinkIcon
          sx={{
            color: props?.color || "#1976d2",
            fontSize: props?.size || "22px",
          }}
        />
      </IconButton>
      {/* </Link> */}
    </Tooltip>
  );
};

export default CustomUniqueURLIcon;
